import { useHistory, useParams } from "react-router-dom";

import i18n from "@/translate/i18n";
import { confirmTransaction } from "@/services/api";

function useSubmitData(setError, setIsFetching, setData) {
  const history = useHistory();
  const { id, token } = useParams();
  const submitData = async (data) => {
    const {
      accepted_terms,
      customer,
      merchant_request_amount,
      bank_amount,
      bank_payment_data,
    } = data;

    try {
      setIsFetching(true);
      const payload = {
        accepted_terms,
        merchant_amount: Number(merchant_request_amount || bank_amount),
        customer_data: {
          document_number: customer?.document_number,
          email: customer?.email,
          country_iso: customer?.country_iso,
          document_type: customer?.document_type,
        },
        ...(bank_payment_data && {
          bank_payment_data: {
            qr_code: bank_payment_data?.qr_code,
            bank_name: bank_payment_data?.bank_name,
            account_id: bank_payment_data?.account_id,
            account_holder: bank_payment_data?.account_holder,
          },
        }),
      };
      const res = await confirmTransaction(id, token, payload);
      if (data?.type === "deposit") {
        setData(res.data);
        history.push(
          `/transaction-details/${id}/${token}${history.location.search}${
            history.location.search.includes("?") ? "&" : "?"
          }source=manual`,
        );
      } else {
        history.push({
          pathname: `/withdrawal/status/${id}/${token}`,
          search: history.location.search,
          state: {
            data: res.data,
            origin: "withdrawal",
          },
        });
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      const retryableErrors = ["invalid document"];

      if (retryableErrors.includes(errorMessage?.toLowerCase())) {
        throw new Error(`RETRYABLE_ERROR:${errorMessage}`);
      }
      setError(i18n.t([`error.${errorMessage}`, "error.unspecific"]));
    } finally {
      setIsFetching(false);
    }
  };

  return { submitData };
}

export default useSubmitData;
